/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelFromJSONTyped,
    BasicModelToJSON,
} from './BasicModel';

/**
 * 
 * @export
 * @interface SubCategoryWithCategoryModel
 */
export interface SubCategoryWithCategoryModel {
    /**
     * 
     * @type {number}
     * @memberof SubCategoryWithCategoryModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SubCategoryWithCategoryModel
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SubCategoryWithCategoryModel
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof SubCategoryWithCategoryModel
     */
    slug?: string | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof SubCategoryWithCategoryModel
     */
    subCategoryTags?: Array<BasicModel> | null;
}

export function SubCategoryWithCategoryModelFromJSON(json: any): SubCategoryWithCategoryModel {
    return SubCategoryWithCategoryModelFromJSONTyped(json, false);
}

export function SubCategoryWithCategoryModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubCategoryWithCategoryModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'rank': !exists(json, 'rank') ? undefined : json['rank'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'subCategoryTags': !exists(json, 'subCategoryTags') ? undefined : (json['subCategoryTags'] === null ? null : (json['subCategoryTags'] as Array<any>).map(BasicModelFromJSON)),
    };
}

export function SubCategoryWithCategoryModelToJSON(value?: SubCategoryWithCategoryModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'rank': value.rank,
        'slug': value.slug,
        'subCategoryTags': value.subCategoryTags === undefined ? undefined : (value.subCategoryTags === null ? null : (value.subCategoryTags as Array<any>).map(BasicModelToJSON)),
    };
}

